import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { lazy, Suspense } from "react";
import CookieConsent from "@/components/CookieConsent";
import StructuredData from "@/components/StructuredData";
import MetaPixel from "@/components/MetaPixel";

// Lazy load pages
const Webseiten = lazy(() => import("./pages/Webseiten"));
const Impressum = lazy(() => import("./pages/Impressum"));
const Datenschutz = lazy(() => import("./pages/Datenschutz"));
const AGB = lazy(() => import("./pages/AGB"));
const WebseitenAnfrage = lazy(() => import("./pages/WebseitenAnfrage"));
const Danke = lazy(() => import("./pages/Danke"));
const Onboarding = lazy(() => import("./pages/Onboarding"));
const KundenOnboarding = lazy(() => import("./pages/KundenOnboarding"));
const WebshopOnboarding = lazy(() => import("./pages/WebshopOnboarding"));
const Admin = lazy(() => import("./pages/Admin"));
const Preiskalkulator = lazy(() => import("./pages/Preiskalkulator"));
const Angebot = lazy(() => import("./pages/Angebot"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

// Minimal loading fallback
const PageFallback = () => <div className="min-h-screen bg-background" />;

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <CookieConsent />
        <MetaPixel />
        <StructuredData />
        <BrowserRouter>
          <Suspense fallback={<PageFallback />}>
            <Routes>
              <Route path="/" element={<Webseiten />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="/agb" element={<AGB />} />
              {/* Redirects for old routes */}
              <Route path="/webseiten" element={<Navigate to="/" replace />} />
              <Route path="/webseiten/anfrage" element={<WebseitenAnfrage />} />
              <Route path="/anfrage" element={<WebseitenAnfrage />} />
              <Route path="/danke" element={<Danke />} />
              <Route path="/onboarding" element={<Onboarding />} />
              <Route path="/kunden-onboarding" element={<KundenOnboarding />} />
              <Route path="/webshop-onboarding" element={<WebshopOnboarding />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/preiskalkulator" element={<Preiskalkulator />} />
              <Route path="/angebot/:id" element={<Angebot />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
